import { Navigate, Route, Routes } from "react-router-dom";

import AdminGuard from "@/features/admin/AdminGuard";
import AgentsPage from "@/features/admin/AgentsPage";
import PromptsPage from "@/features/admin/PromptsPage";
import RuleSuggestionsPage from "@/features/admin/RuleSuggestionsPage";
import UsersPage from "@/features/admin/UsersPage";
import WorkStatsPage from "@/features/admin/WorkStatsPage";
import LoginPage from "@/features/auth/LoginPage";
import ProtectedRoute from "@/features/auth/ProtectedRoute";
import RequirementsPage from "@/features/guide/RequirementsPage";
import JobDetailPage from "@/features/jobs/JobDetailPage";
import JobsListPage from "@/features/jobs/JobsListPage";
import RequestDetailPage from "@/features/requests/RequestDetailPage";
import RequestsListPage from "@/features/requests/RequestsListPage";
import UploadPage from "@/features/upload/UploadPage";
import HomePage from "@/pages/HomePage";
import Layout from "@/pages/Layout";

/**
 * 라우트 구조:
 *   /login         — 공개
 *   /              — 인증 후 진입 (대시보드)
 *   /upload        — 업로드
 *   /jobs          — 처리 이력 목록
 *   /jobs/:id      — Job 상세 (M6-2 에서 채움)
 *   *              — 404 → 홈으로
 */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="upload" element={<UploadPage />} />
          <Route path="requests" element={<RequestsListPage />} />
          <Route path="requests/:id" element={<RequestDetailPage />} />
          <Route path="jobs" element={<JobsListPage />} />
          <Route path="jobs/:id" element={<JobDetailPage />} />
          <Route path="guide" element={<RequirementsPage />} />
          <Route element={<AdminGuard />}>
            <Route path="admin/work-stats" element={<WorkStatsPage />} />
            <Route path="admin/users" element={<UsersPage />} />
            <Route path="admin/agents" element={<AgentsPage />} />
            <Route path="admin/prompts" element={<PromptsPage />} />
            <Route path="admin/suggestions" element={<RuleSuggestionsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
